'use client'

import { useEffect } from 'react'

const DEFAULT_BODY_CLASS = 'interviewPracticeCampaignPage'

/** Campaign pages use their own header/footer and mobile sticky CTA — no app bottom nav. */
export function CampaignBodyClass({ bodyClassName = DEFAULT_BODY_CLASS }: { bodyClassName?: string }) {
  useEffect(() => {
    document.body.classList.add(bodyClassName)
    return () => document.body.classList.remove(bodyClassName)
  }, [bodyClassName])

  return null
}
